import { GroundControlTypeDocument } from '../GroundControlTypes/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  GroundControlSetDocument,
  groundControlSetPushQueryBuilder,
  groundControlSetsPullModifier,
  groundControlSetsPullQueryBuilder,
  groundControlSetsPushModifier,
} from './queryBuilder';

export function groundControlSetsFamilyMember(
  configBuilder: ConfigBuilder,
  groundControlTypes: FamilyMember<GroundControlTypeDocument>,
): FamilyMember<GroundControlSetDocument> {
  const syncConfig = configBuilder<GroundControlSetDocument>(
    RxdbCollectionNameV2.GROUND_CONTROL_SETS,
  );
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, groundControlSetsPullQueryBuilder);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pullConfig.modifier = groundControlSetsPullModifier;

  const pushConfig = push(syncConfig, groundControlSetPushQueryBuilder);
  pushConfig.modifier = groundControlSetsPushModifier;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.GROUND_CONTROL_SETS, replicationState, [groundControlTypes]);
}
